/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Card_You_GetInputs */

const en_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You get back`)
};

const zh_hans1_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你收到`)
};

const pt_br2_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você recebe`)
};

const es_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibes`)
};

const fr_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous recevez`)
};

const de_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bekommst zurück`)
};

const ru_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы получаете`)
};

const it_endpoint_card_you_get = /** @type {(inputs: Endpoint_Card_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ricevi`)
};

/**
* | output |
* | --- |
* | "You get back" |
*
* @param {Endpoint_Card_You_GetInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_card_you_get = /** @type {((inputs?: Endpoint_Card_You_GetInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Card_You_GetInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_card_you_get(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_card_you_get(inputs)
	if (locale === "es") return es_endpoint_card_you_get(inputs)
	if (locale === "fr") return fr_endpoint_card_you_get(inputs)
	if (locale === "de") return de_endpoint_card_you_get(inputs)
	if (locale === "ru") return ru_endpoint_card_you_get(inputs)
	if (locale === "it") return it_endpoint_card_you_get(inputs)
	return en_endpoint_card_you_get(inputs)
});